import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconAddCircleOutlineGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M8.66732 5.18783H7.33398V7.85449H4.66732V9.18783H7.33398V11.8545H8.66732V9.18783H11.334V7.85449H8.66732V5.18783ZM8.00065 1.85449C4.32065 1.85449 1.33398 4.84116 1.33398 8.52116C1.33398 12.2012 4.32065 15.1878 8.00065 15.1878C11.6807 15.1878 14.6673 12.2012 14.6673 8.52116C14.6673 4.84116 11.6807 1.85449 8.00065 1.85449ZM8.00065 13.8545C5.06065 13.8545 2.66732 11.4612 2.66732 8.52116C2.66732 5.58116 5.06065 3.18783 8.00065 3.18783C10.9407 3.18783 13.334 5.58116 13.334 8.52116C13.334 11.4612 10.9407 13.8545 8.00065 13.8545Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconAddCircleOutlineSvg: React.FC<SvgProps> = (props) => {
  const height = props.svg?.height ?? '16';
  const width = props.svg?.width ?? '16';
  return (
    <svg
      viewBox={`0 0 16 16`}
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
      width={width}
      height={height}
    >
      <IconAddCircleOutlineGroup {...props} />
    </svg>
  );
};
